export default __webpack_public_path__ + "static/media/jewish-3.c3be2882.jpg";